import { render } from "./EditPostView.vue?vue&type=template&id=515dda01"
import script from "./EditPostView.vue?vue&type=script&lang=js"
export * from "./EditPostView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__